//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.PackagingBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[0,"Condition",1,0],[0,"MsType",1,0],[0,"StopOnEvent",1,0],[1,"ThresholdAngleExpression",0,"Expression",0],[1,"ThresholdExpression",0,"Expression",0],[1,"ToleranceAngleExpression",0,"Expression",0],[1,"ToleranceExpression",0,"Expression",0]],[[["num_list2"],"GetList2",{R_:{list2:"DisplayableObject[]"}},0,0],[["list2"],"SetList2",{},1,0],[["sourceNum","sourceGeometryData"],"GetSourceList",{},0,0],[["sourceGeometryData"],"SetSourceList",{},1,0],[["targetNum","targetGeometryData"],"GetTargetList",{},0,0],[["targetGeometryData"],"SetTargetList",{},1,0]],[]];
SPLM.Motion.PackagingMeasureBuilder = class extends SPLM.Motion.PackagingBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.PackagingMeasureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.PackagingMeasureBuilder.GeometryData = class{
    constructor(geometry,point,vector,direction){
        this.geometry=geometry;this.point=point;this.vector=vector;this.direction=direction;}
    get Geometry(){return this.geometry}
    set Geometry(val){this.geometry = val}
    get Point(){if(this.point === undefined) this.point = new SPLM.Point3d(); return this.point}
    set Point(val){this.point = val}
    get Vector(){if(this.vector === undefined) this.vector = new SPLM.Vector3d(); return this.vector}
    set Vector(val){this.vector = val}
    get Direction(){return this.direction}
    set Direction(val){this.direction = val}
};

SPLM.Motion.PackagingMeasureBuilder.MeasureType = Object.freeze({
    "MinimumDistance" : "MinimumDistance", "Angle" : "Angle"});

SPLM.Motion.PackagingMeasureBuilder.MeasureCondition = Object.freeze({
    "LessThan" : "LessThan", "GreaterThan" : "GreaterThan", "EqualTo" : "EqualTo"});

export default SPLM;